import { render, staticRenderFns } from "./PlanPost.vue?vue&type=template&id=0fb9269a&"
import script from "./PlanPost.vue?vue&type=script&lang=js&"
export * from "./PlanPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports